<template>
    <div class="user-profile">
        <div class="prof-header">
            <img v-if="profileHasLoadedWithNoError()" 
                class="cover"
                :src="profileImage"
                @error="setDefaultImage"/>
        </div>
        <div class="prof-body">
            <img v-if="profileHasLoadedWithNoError()" 
                class="img" 
                :src="profileImage"
                @error="setDefaultImage"/>
            <LoadingIndicator v-if="profileIsCurrentlyLoading()" message="Loading Profile..."/>
            <SystemMessage v-if=" profileEncounteredAnError()" :message="profErrorMessage"/>
            <div v-if="profileHasLoadedWithNoError()" class="details">
                <div class="prof-info">               
                 <div class="job-title">
                    {{profile.fullName}}
                </div>
                <div class="user-id">
                    {{profile.handle}}
                </div>
                
                <div class="more-details">
                    <div v-if="profile.website" class="more-detail-block">
                        <LinkIcon class="detail-icon" style="color:var(--page-header);"/>
                        <a :href="profile.website" target="blank" style="color:var(--page-header);" class="more-detail">{{ profile.website }}</a>
                    </div>
                    <div class="more-detail-block">  
                        <CalendarIcon class="detail-icon"/>
                        <div class="more-detail">Joined {{ profile.joinDate }}</div>
                    </div>
                    <div class="more-detail-block">
                        <button @click="copyLink(this.$route.params.handle)" class="btn btn-default btn-sm copy-btn">
                            <CopyIcon class="copy-icon"/>
                            <div class="copy-text">
                            {{ isCopied ? 'Copied!' : 'Copy Link' }}
                            </div>
                        </button>
                    </div>
                </div>
                <div v-if="profile.description" class="bio">
                    {{ this.sanitizeDescription(profile.description) }}
                </div>
                </div>  
            </div>
            <div class="page-divider"></div>
            <LoadingIndicator v-if="jobListIsCurrentlyLoading()" message="Getting Jobs..."/>
            <SystemMessage v-else-if="jobListEncounteredAnError()" :message="jobsErrorMessage"/>
              <ProfilePageJobListings ref="jobListings"
                    :title="title"
                    :total="total"
                    :jobs="jobs"
                    :init-loading="jobsLoading"
                    :init-loading-error="jobsError"
                    :get-page-async="getJobListingsAsync"/>
        </div>
    </div>
</template>
<script>
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import CopyIcon from '@/components/IconComponents/CopyIcon.vue';
import { getPublicProfileAsync, getPublicProfileJobListingsAsync } from '@/services/authService';
import LinkIcon from '@/components/IconComponents/LinkIcon.vue';
import CalendarIcon from '@/components/IconComponents/CalendarIcon.vue';
import ProfilePageJobListings from '@/components/Jobs/ProfilePageJobListings.vue';
import DOMPurify from 'dompurify'
import { setPageMeta, stripHtmlTags } from '@/assets/pageMetaGenerator';
export default {
    components:{
        CopyIcon,
        SystemMessage, 
        LoadingIndicator,
        LinkIcon, 
        CalendarIcon,
        ProfilePageJobListings
    },
    data(){
        return{
            url:process.env.VUE_APP_API_URL,
            site_url: process.env.VUE_APP_SITE_URL,
            profileLoading: true,
            jobsLoading: false,
            profileError: false,
            jobsError: false,
            profErrorMessage: "",
            jobsErrorMessage: "",
            profile:{
                userId:"",
                fullName:"",
                handle:"",
                joinDate:"",
                website:"",
                description:""
            },
            isCopied: false,
            title: "Job Listings",
            total:0,
            jobs:[],
            pageNumber:0,
            getAsyncFunction: () => {}
        }
    },
    mounted(){
        //this.$store.dispatch('auth/setHandle', this.$route.params.handle);
        window.scrollTo({top: 0,behavior: 'smooth'});
        if(this.$route.params.handle === null|| this.$route.params.handle === "null"){
            this.$router.push('/');
            }else{
            this.getUser();
        }
    },
    computed:{
        profileImage(){
            return this.url + 'Auth/Image/' + this.profile.userId;
        }
    },
    methods: {
     updateMeta(){
        let description = `Visit the ${this.profile.fullName} profile page to access and apply for jobs posted by them on Vocation.`;
          setPageMeta({
            title: this.profile.fullName,
            description: `${description}`,
            image: this.profileImage,
            url: window.location.href,
          })
        },    
    profileHasLoadedWithNoError(){
        return !this.profileLoading && !this.profileError;
    },
    profileIsCurrentlyLoading(){
        return this.profileLoading;
    },
    profileEncounteredAnError(){
        return !this.profileLoading && this.profileError;
    },

    jobListIsCurrentlyLoading(){
        let profileLoaded = this.profileHasLoadedWithNoError();
        return profileLoaded && this.jobsLoading;
    },
    jobListHasLoadedWithNoError(){
         let profileLoaded = this.profileHasLoadedWithNoError();
         return profileLoaded && !this.JobsLoading && !this.jobsError;
    },
    jobListEncounteredAnError(){
        let profileLoaded = this.profileHasLoadedWithNoError();
        return profileLoaded && !this.JobsLoading && this.jobsError;
    },


    async getUser(){
         try{
             this.ProfileLoading();
             let response = await getPublicProfileAsync(this.$route.params.handle);
             if(!response.success){
                let err = new Error(response.message);
                throw err;
             }else{
             this.profile.userId = response.profile.userId
             this.profile.fullName = response.profile.fullName;
             this.profile.handle = response.profile.handle;
             this.profile.joinDate = response.profile.joinDate;
             this.profile.website = response.profile.website;
             this.profile.description = response.profile.description;
             this.ProfileSuccess();
             this.updateMeta();

             this.$refs.jobListings.getProfileJobListingsPageAsync();
             }
         }catch(e){
            this.ProfileError(e.message);
         }
    },
    async getJobListingsAsync(){
        this.pageNumber+=1;
                if(this.pageNumber == 1){
                this.JobsLoading(); 
                }else{
                this.$refs.jobListings.setButtonToLoadingMore();
                }
                try{
                
                let data = await getPublicProfileJobListingsAsync(this.$route.params.handle, this.pageNumber);
                this.JobsStopLoading(); //stop loading
                if(data.success == true){
                    //check if the first page is empty []
                    if(this.pageNumber == 1 && data.listings.length == 0){
                        let err = new Error();
                        err.message = "This organization has not posted job openings yet.";
                        throw err;
                    }else{
                        //normal feed
                        this.JobsSuccess();
                        this.jobs = data.listings;
                        this.total = data.listings[0].count;
                        this.$refs.jobListings.setButtonToSuccessfulLoad();
                    }  
                }else{
                
                    if(this.pageNumber == 1){
                    this.pageNumber-=1;
                    this.error = true;
                    }else{
                    this.pageNumber-=1;
                    this.$refs.jobListings.setButtonToLoadingError();
                    }
                }
                }catch(e){    
                this.JobsStopLoading();
                if(this.pageNumber == 1){
                    this.pageNumber-=1; //keep this
                    this.error = true;
                    //show empty first page [] error (or any error that might arise)
                    this.errorMessage = e.message;
                }else{
                    this.pageNumber-=1; //keep this
                    this.$refs.jobListings.setButtonToLoadingError();
                }
                }

             
    },
    ProfileLoading(){
        this.profileLoading = true;
        this.profileError = false;
    },
     ProfileSuccess(){
        this.profileLoading = false;
        this.profileError = false;
    },
     ProfileError(message){
        this.profileLoading = false;
        this.profileError = true;
        this.profErrorMessage = message === 'Failed to fetch' ? 'Unable to get this profile. Try refreshing the page': message;
    },
    JobsLoading(){
        this.jobsLoading = true;
        this.jobsError = false;
    },
    JobsSuccess(){
        this.jobsLoading = false;
        this.jobsError = false;
    },
     JobsStopLoading(){
        this.jobsLoading = false;
        this.jobsError = false;
    },
    JobsError(){
        this.jobsLoading = false;
        this.jobsError = true;
    },
    sanitizeDescription(description){
        return DOMPurify.sanitize(description);
    },
    setDefaultImage(event){
        event.target.src = require('@/assets/images/profile_picture.png');
    },
    async copyLink(handle){
      let url = `${window.location.origin}/org/${handle}`
     
      // Check if the modern Clipboard API is available
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(url)
        this.showSuccess()
      } catch (err) {
        
        this.fallbackCopy(url);
      }
    } else {
      // Fallback for insecure raw IP addresses (HTTP)
      this.fallbackCopy(url);
    }
    },
     showSuccess(){
    this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      },3000);
    },
    fallbackCopy(textToCopy) {
    // Create a temporary hidden textarea element
    const textArea = document.createElement('textarea')
    textArea.value = textToCopy
    
    // Avoid scrolling to the bottom of the page when appending
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'
    
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select() // Highlight the text inside

    try {
      // Execute the legacy copy command
      const successful = document.execCommand('copy')
      if (successful) {
        this.showSuccess()
      } else {
        alert('Unable to copy link.')
      }
    } catch (err) {
      alert('Oops, unable to copy!')
    }

    // Clean up by removing the element from the DOM
    document.body.removeChild(textArea)
  },
}


    
}
</script>
<style scoped>

.page-divider{
    margin-bottom:1rem;
}

.copy-icon{
  color:var(--darkgrey3);
  height:1rem;
}

.copy-text{
  color:var(--darkgrey3);
}

.copy-btn{
    margin-top:0.5rem;
    display: flex;
    align-items: center;
    column-gap:0.5rem;
    border:1px solid var(--lightgrey);
}

.bio{
    margin-top:1rem;
    margin-right:4rem;
}
.more-details{
    display:flex;
    flex-direction: column;
}

.more-detail-block{
    display:flex;
    column-gap:0.5rem;
    align-items: center;
    color:var(--darkgrey3);
    margin-bottom:0.2rem;
}

.more-detail{
    flex:1rem;
}

.detail-icon{
    height:1rem;
}

.prof-info{
    grid-column:2/3;
}
.copy-icon{
  color:var(--darkgrey3);
  height:1rem;
}

.copy-icon{
  color:var(--darkgrey3);
  height:1rem;
}

.copy-text{
  color:var(--darkgrey3);
}

.details{
  transform: translateY(1rem); 
  display:grid;
  grid-template-columns:0.5fr 3fr;

}

.job-title{
   font-family: var(--heading-font-bold);
   font-size:1.7rem;
   color:var(--foreground);
   white-space:wrap;
  

}

.user-id{
  font-family: var(--heading-font-bold);
  font-size:0.9rem;
  margin-bottom:0.4rem;
  white-space:wrap;
  color:var(--page-header);
  
}
    .img{
        height:8rem;
        position: absolute;
        transform:translate(2rem,-3rem);
        border-radius:16px;
        border:2px solid var(--background);
        
    }

  
    .user-profile{
        display: grid;
        grid-template-rows: auto auto;
    }

    
    
    .prof-body{
        display: grid;
        position: relative;
    }

    .prof-header{
        height:10rem;
        /* position: relative; */
        background-color: rgb(176, 176, 176);
        overflow: hidden;
        /* object-fit: cover; */
    }

      .cover{
        /* transform: translate(1rem,-30rem); */
        /* position: absolute; */
        width: 100%;
        height: 100%;
        object-fit: cover;
        filter: blur(8px);
        /* Slight scale prevents white/transparent edges caused by CSS blur */
        transform: scale(1.08);
       
        

    }

    @media(max-width: 768px){
         .img{
        height:6rem;
        transform:translate(1rem,-3rem);
        border-radius:12px;
        }

        .details{
            margin-top:2.5rem;
            margin-left:0.8rem;
            margin-right:0.9rem;
            display:block;
           
        }

        .bio{
            margin-top:0.8rem;
            margin-right:0rem;
            line-height:1.3rem;
            font-size:0.9rem;
        }

        .page-divider{
            margin-bottom:0.2rem;
        }
    }
</style>